import { render, staticRenderFns } from "./FooterCard.vue?vue&type=template&id=67ae5f9c&scoped=true&"
import script from "./FooterCard.vue?vue&type=script&lang=js&"
export * from "./FooterCard.vue?vue&type=script&lang=js&"
import style0 from "./FooterCard.vue?vue&type=style&index=0&id=67ae5f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae5f9c",
  null
  
)

export default component.exports